import React from "react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Box,
  Button,
  Field,
  FieldLabel,
  Input,
} from "@salestrak/ui";
import { useRouter } from '#app/lib/hooks/router-compat';
import { requestPasswordReset } from "#app/lib/auth-service";

export function ForgotPasswordForm() {
  const router = useRouter();
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const submit = async () => {
    setError("");
    if (!email.trim()) {
      setError("Email is required.");
      return;
    }
    setIsLoading(true);
    try {
      await requestPasswordReset(email.trim());
      router.replace({
        pathname: "/(auth)/reset-password-sent",
        params: { email: email.trim() },
      });
    } catch (err: any) {
      setError(err.message ?? "Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void submit();
  };

  return (
    <Box as="form" direction="column" gap="xl" onSubmit={handleSubmit}>
      <Field>
        <FieldLabel>Email</FieldLabel>
        <Input
          type="email"
          placeholder="name@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus
          autoComplete="email"
          disabled={isLoading}
        />
      </Field>

      {error ? (
        <Alert variant="error">
          <AlertTitle>Unable to send reset email</AlertTitle>
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      ) : null}

      <Button type="submit" loading={isLoading}>
        Send Reset Link
      </Button>
    </Box>
  );
}
